import React from 'react';
import {
	TextField,
	DateField,
	SimpleShowLayout,
	SelectInput,
} from 'admin-on-rest';
import FilterWithSubmit from '../admin/FilterWithSubmit';
import FormattedDateTextInput from '../components/FormattedDateTextInput';
import List from '../admin/List';
import Show from '../admin/Show';
import ListTableContainer from '../components/ListTableContainer';
import TransferAuditTable from '../components/TransferAuditTable';
import ViewButton from '../buttons/ViewButton';
import { TIME_ZONE_OFFSETS } from '../shared/dateTimeLists';
import { viewStyles } from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/assignment-late';

export const fuseTransferAuditIcon = Icon;

const MakeTransferAuditTable = ({ record }) => {
	const variances = record ? record.variances : [];
	return <TransferAuditTable {...record} variances={variances} />;
};

/*
 * View: List
 */

const TransferAuditFilter = props => {
	return (
		<FilterWithSubmit {...props} updateOnChange={true} displayButton={false}>
			<SelectInput
				source="offset"
				label="Select a Time Zone Offset"
				dependsOn="date_from"
				dependsOnFilterValue={true}
				allowEmpty
				choices={TIME_ZONE_OFFSETS}
				style={viewStyles.filterInline}
				defaultValue={null}
			/>

			<FormattedDateTextInput
				source="date_to"
				label="Date To"
				placeholder="MM/DD/YYYY"
				dependsOn="date_from"
				dependsOnFilterValue={true}
				maxDate={new Date()}
				style={{
					...viewStyles.filterInline,
					...viewStyles.filterDateSelect,
				}}
			/>

			<FormattedDateTextInput
				source="date_from"
				label="Date From"
				placeholder="MM/DD/YYYY"
				alwaysOn
				style={{
					...viewStyles.filterInline,
					...viewStyles.filterDateSelect,
				}}
			/>
		</FilterWithSubmit>
	);
};

const ListTitle = (
	<span>
		<Avatar
			icon={<Icon />}
			style={viewStyles.avatar}
			className="avatar-title"
		/>
		Transfer Audits
	</span>
);

const ListDescription = () => {
	return (
		<span>
			<p>
				When transferring products from one Location to another, a Transfer
				Audit is created to keep track of discrepancies between the claimed
				transfer and actual received items.
			</p>
			<p>
				To view Transfer Audits for a specific period, select a date range and a
				time zone offset.
			</p>
			<p>
				<strong>Note:</strong> The <em>Date To</em> filter must be the same date
				or later than the <em>Date From</em> filter to successfully retrieve
				Audit data.
			</p>
		</span>
	);
};

const ListColumns = [
	{ source: 'transfer_id', label: 'Transfer ID', type: 'text' },
	{ source: 'client.location', label: 'Location', type: 'text' },
	{
		source: 'received_date',
		label: 'Date',
		component: <DateField source="received_date" label="Date" showTime />,
	},
	{
		source: '',
		label: '',
		component: <ViewButton />,
		filterable: false,
		sortable: false,
		width: 90,
	},
	{ source: 'id', label: '', style: viewStyles.hidden },
];

export const fuseTransferAuditList = props => (
	<List
		title={ListTitle}
		desc={<ListDescription />}
		listType="table"
		filters={<TransferAuditFilter />}
		requiresFilter={true}
		allowQueryString={false}
		pagination={null}
		{...props}
	>
		<ListTableContainer
			{...props}
			columns={ListColumns}
			perPage={10}
			currentSort={{ field: 'transfer_id', order: 'ASC' }}
		/>
	</List>
);

/*
 * View: Show
 */

const ShowTitle = ({ record }) => {
	return (
		<span>
			<Avatar
				icon={<Icon />}
				style={viewStyles.avatar}
				className="avatar-title"
			/>
			{record ? `Transfer Audit #${record.transfer_id}` : 'Transfer Audit'}
		</span>
	);
};

const ShowDescription = () => {
	return (
		<span>
			<p>Review Transfer Audit details below.</p>
		</span>
	);
};

/*
 * Show Transfer Audit Table
 */
export const fuseTransferAuditShow = props => (
	<Show title={<ShowTitle />} desc={<ShowDescription />} {...props}>
		<SimpleShowLayout>
			<TextField source="transfer_id" label="Transfer ID" />
			<TextField source="audit_uuid" label="Audit UUID" />
			<TextField
				source="client.location"
				label="Location"
				style={viewStyles.rowShowField}
			/>
			<TextField
				source="client.register"
				label="Register #"
				style={viewStyles.rowShowField}
			/>
			<hr style={viewStyles.break} />
			<TextField source="received_tz" label="Received Date" />
			<MakeTransferAuditTable />
		</SimpleShowLayout>
	</Show>
);



// WEBPACK FOOTER //
// ./src/Fuse/Inventory/transferAudit.js